import { Navigate } from "react-router-dom";
import bgImage from "../assets/images/Login.png";

const PublicRoute = ({ children }) => {
    const isAuthenticated = !!localStorage.getItem("hoast_token");

    if (isAuthenticated) {
        return <Navigate to="/profile" replace />;
    }

    return (
        <div
            className="min-h-screen bg-no-repeat bg-center bg-cover md:bg-[length:100%_100%]"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            {children}
        </div>
    );
};

export default PublicRoute;
